import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button, Input, Row, Switch, Table, Col, Popconfirm, InputNumber, Checkbox, Select } from 'antd';
import NewStyleInput from './NewStyleInput';
import Tooltip from '../../common/Tooltip';
import { useCallback, useState } from 'react';
import { useStore } from '../../../store/store';
import { ColorPaletteButton } from '../../common/ColorPaletteButton';
import LabelledRow from '../../common/LabelledRow';
import FieldGroupLabel from '../../common/boxStyleFields/FieldGroupLabel';
import DuotoneLightIcon from '../../common/DuotoneLightIcon';
import './tableConfig.css';
import { ItemTypes, borderIcons, defaultTextConfiguration, styleCheckbox } from '../../../constants/constants';
import TitleFontSelector from '../../common/TitleFontSelector';
import { useTranslation } from 'react-i18next';
import { maxFontSize, minFontSize, pageHeight, pageWidth } from '../../../constants/gridConfig';
import { TextStyleButtons } from '../../common/TitleConfiguration';
import { BorderOuterOutlined } from '@ant-design/icons';
import { iconButtonStyle, mergeConfigurationTextStyles, navbarButtonStyle } from '../../../utils/styles';
import { NavbarListButton } from '../../Layout/NavbarListButton';
import CheckboxCustom from '../../common/CheckboxCustom';
import { getBoxBorder, hasAllBordersOn } from '../../RichEditor/utils';
import { Checkable } from '../../common/Checkable';
import FontPicker from '../../common/FontPicker';
import { useSectionStylesFilter } from './utils';
import { useShareWithConfigPreview } from '../../../contexts/ConfigPreviewContext';
const selector = ({
  templates,
  configuration,
  setSelectedStyle,
  currentTemplate,
  createTemplateInStore,
  setConfiguration,
  postTemplate,
  styleRules,
  landscape,
  tmp
}) => ({
  templates,
  configuration,
  setSelectedStyle,
  templatable: currentTemplate.templatable,
  createTemplateInStore,
  setConfiguration,
  postTemplate,
  styleRules,
  landscape,
  tmp
});

export const TextTabs = () => {
  const { configuration, setConfiguration, landscape, tmp } = useStore(selector);
  const [selectedStyle, setSelectedStyle] = useState(mergeConfigurationTextStyles(configuration, tmp)[0]);
  // Style montré sur la page d'aperçu du Drawer.
  useShareWithConfigPreview('textStyleId', selectedStyle?.id);
  const [isEditingStyleName, setIsEditingStyleName] = useState(false);
  const { t } = useTranslation();
  let styleList = [...mergeConfigurationTextStyles(configuration, tmp)];
  const { visibleStyles, filter: sectionStylesFilter } =
    useSectionStylesFilter(styleList);
  const styleData = [
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      width: (18 + 16) * 3 + 16,
    },
    {
      title: 'Style',
      dataIndex: 'style',
      key: 'style',
      onCell: (element, rowIndex) => {
        return {
          key: `style-config-${rowIndex}`,
          onClick: (event) => {
            handleSelectedStyle(element);
          },
        };
      },
    }
  ];

  const handleRemoveStyle = (idToRemove) => {
    const newtextStyles = configuration.textStyles.filter(style => style.id !== idToRemove);
    setConfiguration({
      ...configuration.textStyles,
      textStyles: newtextStyles,
    });
  };

  const handleRenameStyle = (ID, event) => {
    let styleToRename = {
      ...configuration.textStyles.find((element) => element.id === ID),
      name: event.target.value,
    };
    setConfiguration({
      textStyles: [
        ...configuration.textStyles.map((tableStyle) => {
          if (tableStyle.id === ID) {
            return styleToRename;
          }
          return tableStyle;
        }),
      ],
    });
    setIsEditingStyleName(null);
    setEditedName('');
    setSelectedStyle(styleToRename);
  };

  const handleCopyStyle = (copiedId) => {
    const copiedStyle = configuration.textStyles.find((s) => s.id === copiedId);
    let newStyle = {
      ...copiedStyle,
      id: configuration.textStylesIdCount + 1,
      name: `${copiedStyle.name} - Copie`,
    };
    let textStyles = [
      ...configuration.textStyles,
      newStyle,
    ];

    setConfiguration({
      ...configuration,
      textStyles,
      textStylesIdCount: configuration.textStylesIdCount + 1,
    });
  };

  const [editedName, setEditedName] = useState('');
  const dataSourceMapped = [];

  const iconStyle = {
    margin: '.5rem',
    fontSize: '1.5em',
  }
  visibleStyles.forEach((element, index) => {
    const cantEdit = element.id === 0 || element.fromTmp === true;
    const textStyleLocked = element.fromTmp === true;
    // Créer une clé unique en combinant l'ID et fromTmp pour éviter les doublons
    const uniqueKey = `tableStyle-${element.id}-${element.fromTmp ? 'tmp' : 'config'}-${index}`;
    dataSourceMapped.push({
      key: uniqueKey,
      id: element.id,
      style:
        isEditingStyleName === element.id ? (
          <Input
            value={editedName}
            id='styleNameInput2'
            style={{ width: '60%' }}
            onChange={(e) => setEditedName(e.target.value)}
            onPressEnter={(e) => {
              if (!cantEdit && e.target.value.length > 0) {
                handleRenameStyle(element.id, e);
              }
            }}
            onBlur={(e) => {
              if (!cantEdit && e.target.value.length > 0) {
                handleRenameStyle(element.id, e);
              }
            }}
          />
        ) : (
          element.name
        ),
      actions: (
        <div>
          <Tooltip
            placement='bottom'
            mouseLeaveDelay='0'
            title={'Renommer'}
          >
            <FontAwesomeIcon
              icon={icon({ name: 'edit', style: 'light' })}
              style={{
                ...iconStyle,
                color: cantEdit ? 'lightgray' : 'black',
              }}
              onClick={cantEdit ? null : (e) => {
                setIsEditingStyleName(element.id);
                setEditedName(element.name);
              }}
            />
          </Tooltip>
          <Tooltip
            placement='bottom'
            mouseLeaveDelay='0'
            title={'Dupliquer'}
          >
            <FontAwesomeIcon
              icon={icon({ name: 'copy', style: 'light' })}
              style={{
                ...iconStyle,
                color: textStyleLocked ? 'lightgray' : 'black',
              }}
              onClick={textStyleLocked ? null : (e) => handleCopyStyle(element.id)}
            />
          </Tooltip>
          <Tooltip
            placement='bottom'
            mouseLeaveDelay='0'
            title={'Supprimer'}
          >
            {cantEdit ? (
              <FontAwesomeIcon
                icon={icon({ name: 'trash', style: 'light' })}
                style={{
                  ...iconStyle,
                  color: 'lightgray'
                }}
              />
            ) : (
              <Popconfirm
                title='Voulez vous vraiment supprimer ce style ?'
                onConfirm={() => { handleRemoveStyle(element.id); }}
                okText='Oui'
                cancelText='Non'
              >
                <FontAwesomeIcon
                  icon={icon({ name: 'trash', style: 'light' })}
                  style={{
                    ...iconStyle,
                    color: 'red'
                  }}
                />
              </Popconfirm>
            )}
          </Tooltip>
        </div>
      ),
    });
  });

  const [isAddTableStyleLoading, setIsAddTableStyleLoading] = useState(false);

  const handleSelectedStyle = (e) => {
    mergeConfigurationTextStyles(configuration, tmp).forEach((element) => {
      if (element.id === e.id) {
        setSelectedStyle(element);
      }
    });
    return selectedStyle;
  };

  const loadingAnimation = () => {
    setIsAddTableStyleLoading(true);
    setTimeout(() => {
      setIsAddTableStyleLoading(false);
    }, 1000);
  };

  // const handleChange
  const handleSaveChanges = (updatedTableStyle) => {
    const updatedTableStyleIndex = configuration.textStyles.findIndex(
      (element) => element.id === updatedTableStyle.id
    );
    let newtextStyles = [...configuration.textStyles];
    newtextStyles[updatedTableStyleIndex] = updatedTableStyle;
    setSelectedStyle(updatedTableStyle);
    setConfiguration({
      ...configuration.textStyles,
      textStyles: newtextStyles
    });
  };

  const handleAddTableStyle = (newStyleName) => {
    loadingAnimation();
    const newStyle = {
      ...defaultTextConfiguration,
      id: configuration.textStylesIdCount,
      name: newStyleName,
      fontFamily: configuration.fontFamily,
    };
    let textStyles = [
      ...configuration.textStyles,
      newStyle,
    ];
    setConfiguration({
      ...configuration,
      textStyles,
      textStylesIdCount: configuration.textStylesIdCount + 1,
    });
    setSelectedStyle({ ...newStyle });
  };

  const handleChangeFontSize = useCallback(() => (value) => {

    handleSaveChanges({
      ...selectedStyle,
      fontSize: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeColor = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      color: { "label": value, "style": configuration.colors.find((color) => color.label === value).style },
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeBackgroundColor = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      backgroundColor: { "label": value, "style": configuration.colors.find((color) => color.label === value).style },
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeBorderColor = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      border: {
        ...selectedStyle.border,
        color: { "label": value, "style": configuration.colors.find((color) => color.label === value).style }
      }
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeBorderSize = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      border: {
        ...selectedStyle.border,
        size: value,
      }
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeBorderRadius = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      border: {
        ...selectedStyle.border,
        radius: value,
      }
    });
  }, [handleSaveChanges, selectedStyle]);



  const handleChangeSeparator = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      separator: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeWidth = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      width: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeBorderPlace = useCallback(() => (value) => {
    if (value === 'all') {
      handleSaveChanges({
        ...selectedStyle,
        border: {
          ...selectedStyle.border,
          top: true,
          bottom: true,
          left: true,
          right: true,
        },
      });
    } else {
      handleSaveChanges({
        ...selectedStyle,
        border: {
          ...selectedStyle.border,
          [value]: !selectedStyle.border[value],
        },
      });
    }

  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangePaddingTop = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      paddingTopBottom: value,
    });
  }, [handleSaveChanges, selectedStyle]);
  const handleChangePaddingLateral = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      paddinngLeftRight: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeFontFamily = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      fontFamily: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangePosition = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      positions: { horizontal: value },
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleImagePositionInText = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      imagePosition: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeFontWeight = useCallback(() => () => {
    handleSaveChanges({
      ...selectedStyle,
      fontWeight: selectedStyle?.fontWeight ? '' : 'bold',
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeTextDecoration = useCallback(() => () => {
    handleSaveChanges({
      ...selectedStyle,
      textDecoration: selectedStyle?.textDecoration ? '' : 'underline',
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeFontStyle = useCallback(() => () => {
    handleSaveChanges({
      ...selectedStyle,
      fontStyle: selectedStyle?.fontStyle ? '' : 'italic',
    });
  }, [handleSaveChanges, selectedStyle]);

  const changeHandler = useCallback(() => ({
    borderRadius: handleChangeBorderRadius(),
    backgroundColor: handleChangeBackgroundColor(),
    borderSize: handleChangeBorderSize(),
    borderColor: handleChangeBorderColor(),
    color: handleChangeColor(),
    fontSize: handleChangeFontSize(),
    paddingTop: handleChangePaddingTop(),
    paddingLateral: handleChangePaddingLateral(),
    position: handleChangePosition(),
    width: handleChangeWidth(),
    separator: handleChangeSeparator(),
    borderPlace: handleChangeBorderPlace(),
    fontFamily: handleChangeFontFamily(),
    fontWeight: handleChangeFontWeight(),
    textDecoration: handleChangeTextDecoration(),
    fontStyle: handleChangeFontStyle(),
    imagePositionInText: handleImagePositionInText(),
  }), [
    handleChangeBackgroundColor,
    handleChangeBorderRadius,
    handleChangeColor,
    handleChangeBorderColor,
    handleChangeBorderSize,
    handleChangeFontSize,
    handleChangePaddingTop,
    handleChangePosition,
    handleChangeWidth,
    handleChangeSeparator,
    handleChangeBorderPlace,
    handleChangePaddingLateral,
    handleChangeFontFamily,
    handleChangeFontWeight,
    handleChangeTextDecoration,
    handleChangeFontStyle,
    handleImagePositionInText,
  ])



  return (
    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
      <div style={{ textAlign: 'center', width: "40%" }}>
        <h5>Liste des styles des champs textes</h5>
        <NewStyleInput onAdd={handleAddTableStyle} loading={isAddTableStyleLoading} />
        {sectionStylesFilter}
        <Table
          columns={styleData}
          dataSource={dataSourceMapped}
          rowClassName={(record, _rowIndex) => { return record.style === selectedStyle.name ? 'tableSelectedRow' : '' }}
          pagination={false}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", width: "60%", margin: 20 }}>
        {/* Remonté à chaque changement de modèle : ces champs gardent leur
            valeur de départ, ils montreraient sinon celle du modèle d'avant. */}
        <div style={{ width: "100%" }} key={selectedStyle?.id}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
            <FieldGroupLabel>Affichage</FieldGroupLabel>
            <LabelledRow label="Couleur de fond">
              <ColorPaletteButton
                title="Couleur de fond"
                icon={<DuotoneLightIcon name='fill-drip' style={iconButtonStyle()} />}
                onChange={(e) => changeHandler().backgroundColor(e)}
                colors={configuration.colors}
                value={selectedStyle?.backgroundColor}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>

            <LabelledRow label="Couleur des bordures">
              <ColorPaletteButton
                title="Couleur des bordures"
                icon={<DuotoneLightIcon name='border-outer' style={iconButtonStyle()} />}
                colorInIcon='primary'
                onChange={(e) => changeHandler().borderColor(e)}
                colors={configuration.colors}
                value={selectedStyle?.border?.color}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>
            <LabelledRow label="Taille de la bordure">
              <InputNumber
                defaultValue={selectedStyle?.border?.size}
                min={0}
                max={20}
                disabled={selectedStyle?.fromTmp}
                onChange={(e) => changeHandler().borderSize(e)}
                style={{ marginLeft: '5px' }}
              />
            </LabelledRow>
            <LabelledRow label="Radius de la bordure">
              <InputNumber
                defaultValue={selectedStyle?.border.radius}
                min={0}
                disabled={selectedStyle?.fromTmp}
                max={20}
                onChange={(e) => changeHandler().borderRadius(e)}
                style={{ marginLeft: '5px' }}
              />
            </LabelledRow>
            <LabelledRow label="Taille du champ texte dans les colonnes dessins">
              <div style={{ display: 'flex', alignItems: "center", gap: 5 }}>
                <InputNumber
                  defaultValue={selectedStyle?.width}
                  min={0}
                  disabled={selectedStyle?.fromTmp}
                  max={800}
                  onChange={(e) => changeHandler().width(e)}
                  style={{ marginLeft: '5px' }}
                />
              </div>
            </LabelledRow>
            <LabelledRow label="Marge hauteur">
              <InputNumber
                defaultValue={selectedStyle?.paddingTopBottom}
                min={0}
                max={40}
                disabled={selectedStyle?.fromTmp}
                onChange={(e) => changeHandler().paddingTop(e)}
                style={{ marginLeft: '5px' }}
              />
            </LabelledRow>
            <LabelledRow label="Marge latérale">
              <InputNumber
                defaultValue={selectedStyle?.paddinngLeftRight}
                min={0}
                max={40}
                onChange={(e) => changeHandler().paddingLateral(e)}
                style={{ marginLeft: '5px' }}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>

            <LabelledRow label="Bordures affichées">
              {['top', 'bottom', 'left', 'right'].map((border) => (
                <Button
                  key={`border-${border}`}
                  disabled={selectedStyle?.fromTmp}
                  onClick={() => changeHandler().borderPlace(border)}
                  className={`RichEditor-styleButton ${selectedStyle?.border[border]
                    ? '  RichEditor-activeButton'
                    : ''
                    }`}
                  icon={borderIcons[border]}
                />
              ))}
              <Button
                disabled={selectedStyle?.fromTmp}
                className={`RichEditor-styleButton ${selectedStyle?.border?.right === true &&
                  selectedStyle?.border.left === true &&
                  selectedStyle?.border.top === true &&
                  selectedStyle?.border.bottom === true
                  ? '  RichEditor-activeButton'
                  : ''
                  }`}
                onClick={() => changeHandler().borderPlace('all')}
                icon={<BorderOuterOutlined />}
              />
            </LabelledRow>

          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
            <FieldGroupLabel>Texte</FieldGroupLabel>
            <LabelledRow label='Couleur du texte'>
              <ColorPaletteButton
                title='Couleur du texte'
                onChange={(e) => changeHandler().color(e)}
                disabled={selectedStyle.id === 0 || selectedStyle?.fromTmp}
                colors={configuration.colors}
                value={selectedStyle.id === 0 ? configuration.baseFontColor : selectedStyle?.color}
              />
            </LabelledRow>
            <LabelledRow label="Police des labels">
              <FontPicker onChange={(e) => changeHandler().fontFamily(e)}
                disabled={selectedStyle.id === 0 || selectedStyle?.fromTmp}
                forcedValue={selectedStyle.id === 0 ? configuration.fontFamily : selectedStyle?.fontFamily} />
            </LabelledRow>
            <LabelledRow label={t('font-size')}>
              <InputNumber
                min={minFontSize}
                max={maxFontSize}
                disabled={selectedStyle.id === 0 || selectedStyle?.fromTmp}
                defaultValue={selectedStyle.id === 0 ? configuration.fontSize : selectedStyle?.fontSize}
                onChange={(e) => changeHandler().fontSize(e)}
                style={{ marginLeft: '5px' }}
              />
            </LabelledRow>
            <LabelledRow label="Position du texte">
              <Select
                options={[{ value: "left", label: 'Gauche' }, { value: "center", label: 'Centre' }, { value: "right", label: 'Droite' }]}
                onChange={(e) => changeHandler().position(e)}
                disabled={selectedStyle?.fromTmp}
                defaultValue={selectedStyle?.positions?.horizontal}
              ></Select>
            </LabelledRow>
            <LabelledRow label='Style du texte'>
              <TextStyleButtons
                rules={selectedStyle}
                changeHandler={changeHandler()}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>
            <LabelledRow label="Position de l'image dans le texte">
              <Select
                options={[{ value: "start", label: <i class="fa-duotone fa-solid fa-objects-align-top"></i> },
                { value: "center", label: <i class="fa-duotone fa-solid fa-objects-align-center-vertical"></i> },
                { value: "end", label: <i class="fa-duotone fa-solid fa-objects-align-bottom"></i> }]}
                onChange={(e) => changeHandler().imagePositionInText(e)}
                defaultValue={selectedStyle?.imagePosition}
              ></Select>
            </LabelledRow>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TextTabs;
